import { render, staticRenderFns } from "./signUp.vue?vue&type=template&id=581571c8&scoped=true"
import script from "./signUp.vue?vue&type=script&lang=js"
export * from "./signUp.vue?vue&type=script&lang=js"
import style0 from "./signUp.vue?vue&type=style&index=0&id=581571c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581571c8",
  null
  
)

export default component.exports